/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  Grid,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Stack,
  TableBody,
  Alert,
} from "@mui/material";
import FormTitle from "../../../form-fields/form-title";
import TextInput from "../../../form-fields/text-input";
import SelectInput from "../../../form-fields/select-input";
import DashBoardContainer from "../../../layout/dashboard-container";
import {
  FormLabel,
  FormValue,
  GridRow,
} from "../generate-receipt/custom-form-grid";
import { useSelector } from "react-redux";
import { labels } from "../../../../lang/labels";
import { useFormik, FormikProvider, Form } from "formik";
import { useNavigate } from "react-router-dom";
// import { Print } from "@mui/icons-material";
// import ReceiptIcon from "@mui/icons-material/Receipt";
import FormButtons from "../buttons";
import DateInput from "../../../form-fields/date-picker";
import useApiState from "../../common/useApiState";
import useApi from "../../../common/useApiHook";
import {
  saveStampStock,
  zoneWiseStampStock,
} from "../../../../services/stamp-service";
import Loader from "../../../loader/loader";
import AlertMsg from "../../../common/alert";
import { saveStampStockSchema } from "../../../../utils/validation-schema";
import { getUserZoneList } from "../../../../services/coinage-challan-service";
import { getCurrentDate, getErrorMsg } from "../../../../utils/helpers";
import { showToastError } from "../../../common/toastHelper";

const RevenueStampRegister = () => {
  const navigate = useNavigate();
  //const { loading, setLoading, error, setError } = useApiState();

  const initialState = {
    zoneName: "",
    counterName: "",
    receiveDate: getCurrentDate(),
    costPerStamp: "",
    noOfStamp: "",
  };

  const { loading, error, callApi, setError, success, setSuccess } =
    useApi(saveStampStock);

  const lang = useSelector((state) => state.userDetails.lang);
  const formik = useFormik({
    initialValues: initialState,
    validationSchema: saveStampStockSchema,
  });

  // eslint-disable-next-line no-unused-vars
  const [counterList, setCounterList] = useState([
    { value: 1, label: "1" },
    { value: 2, label: "2" },
  ]);

  const [zones, setZoneList] = useState([]);
  const [zoneWiseRes, setZoneWiseRes] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const zoneListRes = await getUserZoneList();
        const zoneList = zoneListRes.map((record) => ({
          value: record.zonename,
          label: record.zonename,
        }));
        setZoneList(zoneList);
      } catch (error) {
        showToastError(getErrorMsg(error));
      }
    };

    fetchData();
  }, []); // Empty dependency array ensures it runs only once

  const handleSubmitButtonClick = async (e) => {
    e.preventDefault();
    const response = await callApi(formik.values);
    // Check if zone is selected and call the dropdown API
    if (formik.values.zoneName) {
      await handleOnChange({ target: { name: "zoneName", value: formik.values.zoneName } });
    }
    formik.resetForm(); // Resets all form fields to initial state
  };

  const handleOnChange = async (e) => {
    const { name, value } = e.target;
    try {
      setError("");
      //setLoading(true);
      const response = await zoneWiseStampStock(value);
      setZoneWiseRes(response.lst);
      //setLoading(false);
    } catch (error) {
      showToastError(getErrorMsg(error));
    } finally {
      //setLoading(false);
    }
  };

  return (
    <DashBoardContainer>
      {loading && <Loader />}
      {error && (
        <AlertMsg
          severity="error"
          onClose={() => {
            setError("");
          }}
        />
      )}
      {success && (
        <Alert
          severity="success"
          onClose={() => {
            setSuccess("");
          }}
        >
          Success: Stamp registered.
        </Alert>
      )}
      <FormikProvider value={formik}>
        <Form>
          <Paper elevation={4} sx={{ marginBottom: "15px" }}>
            <FormTitle title={labels.stampStockRegister[lang]} />
            <Grid>
              <GridRow>
                <FormLabel label={labels.Zone[lang]} required />
                <FormValue
                  component={
                    <SelectInput
                      name="zoneName"
                      options={zones}
                      required
                      onChange={handleOnChange}
                    />
                  }
                />
                <FormLabel label={labels.Counter[lang]} required />
                <FormValue
                  component={
                    <SelectInput
                      name="counterName"
                      options={counterList}
                      required
                    />
                  }
                />
              </GridRow>
              <GridRow>
                <FormLabel label={labels.costPerStamp[lang]} required />
                <FormValue
                  component={<TextInput name="costPerStamp" />}
                  required
                />
                <FormLabel label={labels.noOfStamps[lang]} required />
                <FormValue
                  component={<TextInput name="noOfStamp" />}
                  required
                />
              </GridRow>
              <GridRow>
                <FormLabel label={labels.receiveDate[lang]} required />
                <FormValue
                  component={<DateInput name="receiveDate" required />}
                />
              </GridRow>
              <Grid container justifyContent="center" alignItems="center">
                <Grid
                  item
                  md={3}
                  container
                  justifyContent={{ md: "flex-end" }}
                  alignItems="center"
                  p={2}
                >
                  <FormButtons
                    isValid={!(formik.isValid && formik.dirty)}
                    handleSubmitButtonClick={handleSubmitButtonClick}
                    resetForm={() => {
                      formik.resetForm();
                      setError("");
                      setSuccess("");
                      setZoneWiseRes("");
                    }}
                    submitBtnLabel="Save"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Paper>
          {zoneWiseRes ? (
            <GridRow>
              <TableContainer style={{ padding: "50px" }}>
                <Table
                  size="small"
                  sx={{ minWidth: 600 }}
                  aria-label="simple table"
                >
                  <TableHead>
                    <TableRow
                      sx={{
                        background: "#e6eaeb",
                        "&:last-child td, &:last-child th": {
                          border: "1px solid black",
                        },
                      }}
                    >
                      <TableCell align="center">{labels.SrNo[lang]}</TableCell>
                      <TableCell align="center">
                        {labels.CounterName[lang]}
                      </TableCell>
                      <TableCell align="center">
                        {labels.receiveDate[lang]}
                      </TableCell>
                      <TableCell align="center">
                        {labels.noOfStamps[lang]}
                      </TableCell>
                      <TableCell align="center">
                        {labels.costOfStamp[lang]}
                      </TableCell>
                      <TableCell align="center">
                        {labels.balStamp[lang]}
                      </TableCell>
                      <TableCell align="center">
                        {labels.currentStock[lang]}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {zoneWiseRes?.length > 0 ? (
                      zoneWiseRes.map((item, index) => (
                        <TableRow>
                          <TableCell align="center" className="cellBorder">
                            {index + 1}
                          </TableCell>
                          <TableCell align="center" className="cellBorder">
                            {item.counterName}
                          </TableCell>
                          <TableCell align="center" className="cellBorder">
                            {item.receiveDate}
                          </TableCell>
                          <TableCell align="center" className="cellBorder">
                            {item.noOfStamp}
                          </TableCell>
                          <TableCell align="center" className="cellBorder">
                            {item.costPerStamp}
                          </TableCell>
                          <TableCell
                            align="center"
                            className="cellBorder"
                          ></TableCell>
                          <TableCell
                            align="center"
                            className="cellBorder"
                          ></TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          align="center"
                          className="cellBorder"
                          colSpan={"7"}
                        >
                          No Record Found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </GridRow>
          ) : (
            <> </>
          )}
        </Form>
      </FormikProvider>
    </DashBoardContainer>
  );
};
export default RevenueStampRegister;
